module.exports = __webpack_public_path__ + "static/cipDetail.c317a75e.png";